import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Search = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M20.667 17.778h-1.053l-0.373-0.343c1.307-1.448 2.093-3.327 2.093-5.371 0-4.559-3.88-8.254-8.667-8.254s-8.667 3.695-8.667 8.254c0 4.559 3.88 8.254 8.667 8.254 2.147 0 4.12-0.749 5.64-1.994l0.36 0.356v1.003l6.667 6.337 1.987-1.892-6.653-6.349zM12.667 17.778c-3.32 0-6-2.552-6-5.714s2.68-5.714 6-5.714c3.32 0 6 2.552 6 5.714s-2.68 5.714-6 5.714z"></path>{' '}
  </SvgIcon>
);

export default Search;
